export default "__VITE_ASSET__CAMMFbEf__"